var render = function render(){var _vm=this,_c=_vm._self._c;return _c('with-title',{attrs:{"title":_vm.$t('combined_products_tab_title')}},[_c('Catalog',{staticClass:"product-combined-products__catalog",attrs:{"endpoint":"/shop/catalog/get-combined-products/","product-uid":_vm.productUid,"product-page":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }